import {
  CheckCircle2,
  Clock,
  XCircle,
  FileWarning,
} from "lucide-react";

export const ATTENDANCE_STATUS_BTNS = [
  {
    val: "Present",
    icon: CheckCircle2,
    label: "Có",
    shortLabel: "Có",
    active: "bg-white text-emerald-600 shadow-sm",
    ring: "ring-emerald-200",
  },
  {
    val: "Late",
    icon: Clock,
    label: "Muộn",
    shortLabel: "Muộn",
    active: "bg-white text-orange-600 shadow-sm",
    ring: "ring-orange-200",
  },
  {
    val: "AbsentExcused",
    icon: FileWarning,
    label: "Vắng CP",
    shortLabel: "CP",
    active: "bg-white text-sky-600 shadow-sm",
    ring: "ring-sky-200",
  },
  {
    val: "AbsentUnexcused",
    icon: XCircle,
    label: "Vắng KP",
    shortLabel: "KP",
    active: "bg-white text-red-600 shadow-sm",
    ring: "ring-red-200",
  },
];

export function normalizeAttendanceStatus(status) {
  const s = String(status || "Present");
  if (s === "Absent") return "AbsentUnexcused";
  if (ATTENDANCE_STATUS_BTNS.some((b) => b.val === s)) return s;
  return "Present";
}

export function isAbsentStatus(status) {
  return ["Absent", "AbsentExcused", "AbsentUnexcused"].includes(
    String(status || "")
  );
}

export function attendanceStatusLabel(status) {
  const normalized = normalizeAttendanceStatus(status);
  const btn = ATTENDANCE_STATUS_BTNS.find((b) => b.val === normalized);
  if (btn) return btn.label;
  if (normalized === "AbsentUnexcused") return "Vắng không phép";
  if (normalized === "AbsentExcused") return "Vắng có phép";
  return normalized;
}

export function countAbsentStatuses(list = []) {
  return list.filter((item) => isAbsentStatus(item.status)).length;
}
